import getWindow from 'get-window';

import { isBlockRangeSelection, type Value } from '@gitbook/slate';

import type { EditorContainer } from '../interfaces';

/**
 * Remove content from the value after it has been cut.
 */
export function removeCutContent(event: ClipboardEvent, value: Value, editor: EditorContainer) {
    if (editor.readOnly) {
        // We can only copy the content, so stop here
        return;
    }

    const { selection } = value;
    const window = getWindow(event.target);

    // Once the fake cut content has successfully been added to the clipboard,
    // delete the content in the current selection.
    window.requestAnimationFrame(() => {
        // after copy move a block selection to text selection cursor at the start of the focus node
        if (isBlockRangeSelection(selection)) {
            editor.change((change) => change.deleteBlockRangeForward());
            return;
        }
        // If user cuts a void block node or a void inline node,
        // manually removes it since selection is collapsed in this case.
        const { endBlock, endInline, isCollapsed } = value;
        const isVoidBlock = endBlock?.isVoid && isCollapsed;
        const isVoidInline = endInline?.isVoid && isCollapsed;

        if (isVoidBlock) {
            editor.change((c) => c.removeNodeByKey(endBlock.key));
        } else if (isVoidInline) {
            editor.change((c) => c.removeNodeByKey(endInline.key));
        } else {
            editor.change((c) => c.delete());
        }
    });
}
